// src/helpers/factories/register/discountsFactory.ts
var filterReasons = (reasons, filterFn) => {
  return Object.values(reasons).filter(filterFn).sort(
    (discountA, discountB) => discountA.sortPriority - discountB.sortPriority
  ).map((reason) => ({
    value: reason.discountReasonId,
    label: reason.posName
  }));
};
var discountReasonsDropdownFactory = (discountReasons) => {
  return filterReasons(
    discountReasons,
    (discountReason) => discountReason.active && discountReason.isDiscount
  );
};
var voidReasonsDropdownFactory = (voidReasons) => {
  return filterReasons(
    voidReasons,
    (discountReason) => discountReason.active && discountReason.isVoid
  );
};

export { discountReasonsDropdownFactory, voidReasonsDropdownFactory };
